import PropTypes from 'prop-types';
import React from 'react';
import { Editor } from 'react-draft-wysiwyg';

import {
  generateHtmlFrom,
} from '../../../shared/htmlEditorUtils';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

export class DraftEditor extends React.Component {
  // Synchronize the field input value with the editor state object (aka. editor content)
  // by converting the editor content object to raw html and use that to set the field input value.
  // Reduce the html conversion by calling the process only during the on blur event (When editor loses focus).
  // handleOnBlur = (event, editorState) => {
  handleOnBlur = (event, editorState) => {
    const {
      field,
    } = this.props;

    const html = generateHtmlFrom(editorState);
    if (html) {
      field.input.onChange(html);
    }
  }

  render() {
    const {
      field,
      editorState,
      qaTag,
      ariaLabelledBy,
      ariaDescribedBy,
      editorClassName,
      onEditorStateChange,
    } = this.props;

    const toolbar = {
      options: ['inline', 'list', 'history'],
      inline: {
        inDropdown: false,
        options: ['bold', 'italic', 'underline'],
      },
      list: { inDropdown: false,
        options: ['ordered', 'unordered'],
      },
      history: { inDropdown: false },
    };

    return (
      <div
        id={field.input.name}
        data-qa-item={qaTag}
      >
        <Editor
          editorState={editorState}
          onEditorStateChange={onEditorStateChange}
          onBlur={this.handleOnBlur}
          toolbar={toolbar}
          editorClassName={editorClassName}
          ariaLabelledBy={ariaLabelledBy}
          ariaDescribedBy={ariaDescribedBy}
        />
      </div>
    );
  }
}

DraftEditor.propTypes = {
  field: PropTypes.object.isRequired,
  editorState: PropTypes.object.isRequired,
  onEditorStateChange: PropTypes.func.isRequired,
  ariaLabelledBy: PropTypes.string,
  ariaDescribedBy: PropTypes.string,
  qaTag: PropTypes.string,
  editorClassName: PropTypes.string,
};